import { ref, readonly, reactive } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { LocatableInterface } from './models/locatable.model';
import { useUrlSearchParams } from '@vueuse/core'

export const useGlobalState = createGlobalState(() => {
	const urlparams = useUrlSearchParams('history', { write:  false })

	const dynamicState = reactive<Record<string, any>>({})

	const set = (key: string, value: any): void => {
		dynamicState[key] = value;
	}

	const get = <T = any>(key: string): T | undefined => {
		return dynamicState[key] ?? undefined;
	}

	const debug = ref(false),
		  currentRequest = ref(urlparams),
		  userlocation = ref(TD.location);

	const setLocation = (location: LocatableInterface): void => {
		userlocation.value = location;
	}

	return {
		debug: readonly(debug),
		currentRequest: readonly(currentRequest),
		userlocation: readonly(userlocation),
		setLocation,
		$get: get,
		$set: set,
	}
})

export default useGlobalState;
